import * as React from 'react';
import { CollapsiblePanel } from './CollapsiblePanel';
import { ICollapsiblePanel } from './CollapsiblePanel.interfaces';

export default CollapsiblePanel as any as React.StatelessComponent<ICollapsiblePanel>;
